import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TiimeAutocompleteModule, TiimeOptionModule } from 'tiime-material';

import { AutocompleteBaseComponent } from '@bases/autocomplete/autocomplete.base';
import { ContractAnnexModel } from '@gi/models/contract-annex-model';

@Component({
  standalone: true,
  selector: 'app-annex-model-autocomplete',
  templateUrl: './annex-model-autocomplete.component.html',
  styleUrls: ['./annex-model-autocomplete.component.scss'],
  exportAs: 'AnnexModelAutocomplete',
  imports: [TiimeAutocompleteModule, TiimeOptionModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnnexModelAutocompleteComponent extends AutocompleteBaseComponent<ContractAnnexModel> {}
